// src/utils/sanitize.js

export const sanitizeReg = (v) => (v || '').toUpperCase().replace(/[^A-Z0-9 ]/g, '').trim().slice(0, 10);
export const sanitizeChassis = (v) => (v || '').toUpperCase().replace(/[^A-Z0-9-]/g, '').slice(0, 20);
export const sanitizeEngine = (v) => (v || '').toUpperCase().replace(/[^A-Z0-9-]/g, '').slice(0, 25);
export const sanitizeLogbook = (v) => (v || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 10);
export const sanitizeAlpha = (v, max = 50) => (v || '').replace(/[^a-zA-Z -]/g, '').trim().slice(0, max);
export const sanitizeEmail = (v) => (v || '').toLowerCase().trim().slice(0, 150);
export const sanitizeKraPin = (v) => (v || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 11);
export const clampInt = (v, min, max) => {
  const n = parseInt(v, 10);
  if (Number.isNaN(n)) return '';
  return Math.min(Math.max(n, min), max);
};
export const normalizePhone = (v) => {
  const d = (v || '').replace(/\D/g, '');
  if (d.startsWith('254') && d.length === 12) return `0${d.slice(3)}`;
  if (d.startsWith('0') && d.length === 10) return d;
  if ((d.startsWith('7') || d.startsWith('1')) && d.length === 9) return `0${d}`;
  return d.slice(0, 10);
};

export const validateKraPin = (v) => /^[A-Z]\d{9}[A-Z]$/.test(v || '');
export const validateEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v || '');
export const validateId = (v) => /^\d{8,9}$/.test(v || '');
export const validatePhone = (v) => /^0[17]\d{8}$/.test(v || '');

export const validateChassis = (v) => /^[A-Z0-9\-\s]{10,20}$/i.test((v || '').trim());
export const validateEngineNo = (v) => /^[A-Z0-9-]{6,25}$/.test(v || '');
export const validateLogbook = (v) => /^[A-Z]\d{7}[A-Z]$/.test(v || '');
export const validateColor = (v) => (v || '').length >= 2 && (v || '').length <= 20;
export const validateEngineSize = (v) => {
  const n = parseInt(v, 10);
  return !Number.isNaN(n) && n >= 50 && n <= 9999;
};
export const validateSeats = (v) => {
  const n = parseInt(v, 10);
  return !Number.isNaN(n) && n >= 1 && n <= 100;
};
